import { NgStyle } from '@angular/common'
import { Component, input, OnInit } from '@angular/core'

import { TitleContent } from 'app/_shared/interfaces/config'
import { NormalizeHtmlPipe } from 'app/_shared/pipes/normalizeHtml.pipe'

@Component({
  selector: 'app-title',
  imports: [NgStyle, NormalizeHtmlPipe],
  templateUrl: './title.component.html',
  styleUrl: './title.component.scss'
})
export class TitleComponent implements OnInit {
  section = input.required<{ content: TitleContent }>()
  content: TitleContent

  ngOnInit() {
    this.content = this.section().content
  }
}
